import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ViewSDKClient from '../../utils/viewSDKClient';
import getDocumentUrl from '../../services/documentUrl';

const PdfDiv = ({ signatureRequestId }) => {
  const [pdfObject, setPdfObject] = useState('');

  const loadPdf = async () => {
    let pdfUrl;
    await getDocumentUrl(signatureRequestId).then((res) => {
      pdfUrl = URL.createObjectURL(res.data);
      setPdfObject(pdfUrl);
    });

    const viewSDKClient = new ViewSDKClient();
    viewSDKClient.ready().then(async () => {
      await viewSDKClient.previewFile(
        'pdf-div',
        {},
        pdfUrl,
        `${signatureRequestId}.pdf`,
      );
    });
  };

  useEffect(() => {
    loadPdf();
    const cleanup = () => {
      URL.revokeObjectURL(pdfObject);
    };
    return cleanup;
  }, [signatureRequestId]);
  return <div style={{ height: '90vh' }}><div id="pdf-div" className="full-window-div" /></div>;
};

PdfDiv.propTypes = {
  signatureRequestId: PropTypes.string.isRequired,
};

export default PdfDiv;
